const ParticipantsActions = {
    ACCESS_PLANNING_PAGE: "accessPlanningPage",
    ALWAYS_AMEND_COMPETENCIES: "alwaysAmendCompetenciesAction",
    ALWAYS_SHOW_REPORT_BUTTON: "alwaysShowReportButtonAction",
    AMEND_APPOINTMENT_SETTINGS_ACTION: "amendAppointmentSettingsAction",
    ANONYMIZE_ACTION: "anonymizeAction",
    CAN_MARK_AS_PRESENT: "canMarkAsPresent",
    CAN_SEE_DASHBOARDS: "canSeeDashboards",
    CAN_SEE_DILEMMA_TEST: "canSeeDilemmaTest",
    CAN_SEE_PLANNING_FILTER: "canSeePlanningFilter",
    CAN_SEE_PROJECT_SUBTITLE: "canSeeProjectSubtitle",
    COPY_REPORT: "copyReport",
    DELETE_PARTICIPANT_ACTION: "deleteParticipantAction",
    FILTER_BY_APPOINTMENT_DATES: "filterByAppointmentDates",
    IMPORT_PARTICIPANTS_ACTION: "importParticipantsAction",
    INVITE_PARTICIPANT_ACTION: "inviteParticipantAction",
    MASQUERADE_ACTION: "masqueradeAction",
    MOVE_PARTICIPANTS_TO_PHASE: "moveParticipantsIntoPhase",
    MOVE_PROJECT_ACTION: "moveProjectAction",
    OPEN_DETAIL_PANEL_ACTION: "openDetailPanelAction",
    OVERRIDE_DECISION_PHASE_2_ACTION: "overrideDecisionPhase2Action",
    REQUEST_ASSESSMENT: "requestAssessmentAction",
    RESET_QUESTIONNAIRE_ACTION: "resetQuestionnaireAction",
    RETRIGGER_SCORES_ACTION: "retriggerScoresAction",
    SEND_REMINDER_ACTION: "sendReminderAction",
    SET_DEFAULT_APPOINTMENT_DATE: "setDefaultAppointmentDate",
    SHOW_REPORT_BUTTON: "showReportButtonAction",
    SWAP_PROGRAM_ITEM_ACTION: "swapProgramItemAction",
    SWITCH_LIVE_PRODUCT_ACTION: "switchLiveProductAction",
    TOGGLE_ABILITY_TESTS_ACTION: "toggleAbilityTestsAction",
    TOGGLE_ADJUSTED_PROGRAM_ACTION: "toggleAdjustedProgramAction",
    TOGGLE_PROGRAM_ITEM_ACTION: "toggleProgramItemAction",
    VIEW_CLIENT_INFO_ACTION: "viewClientInfoAction",
    VIEW_DISABLED_PROJECT_ACTION: "viewDisabledProjectAction",
    VIEW_REPORT_AND_RESULT_INTERNAL: "viewReportAndResultInternal",
    VIEW_RESULTS_ACTION: "resultsAction",
};

export default ParticipantsActions;
